import { Select, TextField } from "@king-ict/eupisi-ui/components";
import { codeBookToSelectData } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import StaticField from "../../components/StaticField/StaticField";
import { ProgramCodeBook } from "../../models/Program";
import { ProgramRequestData } from "../../models/ProgramRequest";
import { ProgramRequestDetailBase } from "../../models/ProgramRequest/ProgramRequestDetail";
import {
    useGetLanguageLevelsQuery,
} from "../../queries/codeBookQuery";
import styles from "./ProgramRequestEdit.module.scss";

interface Props {
    programData: ProgramCodeBook;
    programRequest: ProgramRequestDetailBase;
    programRequestChange?: ProgramRequestDetailBase;
    readonly?: boolean;
    onChange: (e: any) => void;
    errors: any;
}

/** Renders 2 rows for selecting general and business languages */
export function ForeignLanguageProgramInfo({
    programData,
    programRequest,
    programRequestChange,
    readonly = false,
    onChange,
    errors
}: Props) {
    const { t } = useTranslation();
    const { data: languageLevels } = useGetLanguageLevelsQuery();

    const getLanguageLevelsByIds = (languageLevelIds: number[]): string => {
        var resultArray = languageLevels?.filter((value) => languageLevelIds.includes(value.id)).map((value) => value.name);
        if (resultArray) {
            return resultArray!.join(', ');
        }
        return "";
    };

    return (
        <>
            <Row className={styles.rowSpacing}>
                <Col md={4}>
                    <TextField
                        plaintext
                        label={t("common.language")}
                        readonly
                        value={programData.languageName}
                    />
                </Col>
                <Col md={4}>
                    {readonly &&
                        <StaticField
                            label={t("request.languageLevelGeneral")}
                            value={getLanguageLevelsByIds(programRequest.languageLevelGeneralIds)}
                            newValue={getLanguageLevelsByIds(programRequestChange?.languageLevelGeneralIds || [])}
                            className={styles.changedField}
                        />
                    }
                    {!readonly &&
                        <Select
                            multiple
                            label={t("request.languageLevelGeneral")}
                            name={"languageLevelGeneralIds"}
                            value={programRequest.languageLevelGeneralIds}
                            onChange={onChange}
                            errorText={errors?.languageLevelChosen}
                            selectData={codeBookToSelectData(languageLevels)}
                            plaintext={readonly}
                        />
                    }
                </Col>
                <Col md={4}>
                    {readonly &&
                        <StaticField
                            label={t("request.languageLevelBusiness")}
                            value={getLanguageLevelsByIds(programRequest.languageLevelBusinessIds)}
                            newValue={getLanguageLevelsByIds(programRequestChange?.languageLevelBusinessIds || [])}
                            className={styles.changedField}
                        />
                    }
                    {!readonly &&
                        <Select
                            multiple
                            label={t("request.languageLevelBusiness")}
                            name={"languageLevelBusinessIds"}
                            value={programRequest.languageLevelBusinessIds}
                            onChange={onChange}
                            errorText={errors?.languageLevelChosen}
                            selectData={codeBookToSelectData(languageLevels)}
                            plaintext={readonly}
                        />
                    }
                </Col>
            </Row>
        </>
    )
}